import AnimatedBuzzword from './AnimatedBuzzword';
import ArrowButton from './ArrowButton';
import EventsSplide from './EventsSplide';
import FeaturesAnimation from './FeaturesAnimation';
import HorizontalGallery from './HorizontalGallery';
import HeadingsAnimation from './HeadingsAnimation';
import Ticker from './Ticker';
import TitleAnimation from './TitleAnimation';
import WavyButtonAnime from './WavyButtonAnime';


AnimatedBuzzword();
ArrowButton();
EventsSplide();
FeaturesAnimation();
HorizontalGallery();
HeadingsAnimation();
Ticker();
TitleAnimation();
WavyButtonAnime();
